import React, { useState } from "react"
import { injectIntl } from "react-intl"
import Select from "react-select"
import { Intl } from "../../state/helpers/IntlProps"
import { PAYMENT_STATUS } from "../../state/helpers/Payment"
import { getPaymentStatusOptions } from "./utils"

type OwnProps = {
    intl: Intl
    multi: boolean
    onChange: (selectedOpts: string[], selectedOptsLabels: string) => void
}

const PaymentStatusSelect = (props: OwnProps) => {

    const [selectedOption, setSelectedOption] = useState<PAYMENT_STATUS | PAYMENT_STATUS[]>([])

    const onChangeSelect = (selectedOpts) => {

        setSelectedOption(selectedOpts)

        if (props.multi) {
            props.onChange(selectedOpts.map(option => option.value), selectedOpts.map(option => option.label).join(","))
        } else {
            props.onChange(selectedOpts.value, selectedOpts.label)
        }

    }

    return <Select
        id="payment-status-select"
        name="payment-status-select"
        multi={props.multi}
        value={selectedOption}
        onChange={onChangeSelect}
        options={getPaymentStatusOptions(props.intl)}
    />
}

export default injectIntl(PaymentStatusSelect)


// WEBPACK FOOTER //
// ./src/payment/components/paymentStatusSelect.tsx